import React from "react";
import { useState } from "react";
import { useTranslation } from 'react-i18next';

function Billsearch(props) {
  const { t } = useTranslation();
  return (

<input type="search" placeholder={t('search_order_no')} value={props.searchTerm} onChange={props.handleInputChange}/>
                  
    
    );
}

export default Billsearch;
